import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
const StatsAndTestimonials = lazy(() => import('./components/StatsAndTestimonials').then(m => ({
  default: m.StatsAndTestimonials
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Modules = lazy(() => import('./components/Modules').then(m => ({
  default: m.Modules
})));
const ContentPreview = lazy(() => import('./components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const ResourcesPreview = lazy(() => import('./components/ResourcesPreview').then(m => ({
  default: m.ResourcesPreview
})));
const IsForYou = lazy(() => import('./components/IsForYou').then(m => ({
  default: m.IsForYou
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseToast = lazy(() => import('./components/PurchaseToast').then(m => ({
  default: m.PurchaseToast
})));
export function App() {
  const [showPurchaseToast, setShowPurchaseToast] = useState(false);
  useEffect(() => {
    document.documentElement.lang = 'es-AR';
    document.title = 'Matemáticas Sin Lágrimas — Todo el acompañamiento matemático de tu hijo listo.';
    const metaDesc = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    metaDesc.setAttribute('content', 'El sistema definitivo para padres de niños de 8 a 11 años. Diagnóstico del bloqueo real, métodos visuales, fracciones sin llanto y sesiones de 10 minutos que terminan en victoria.');
    if (!document.querySelector('meta[name="description"]')) document.head.appendChild(metaDesc);
    if (!document.querySelector('meta[name="viewport"]')) {
      const viewport = document.createElement('meta');
      viewport.setAttribute('name', 'viewport');
      viewport.setAttribute('content', 'width=device-width, initial-scale=1');
      document.head.appendChild(viewport);
    }
    let jsonLd: HTMLScriptElement | null = null;
    let canonicalEl: HTMLLinkElement | null = null;
    let robotsEl: HTMLMetaElement | null = null;
    let pixelLoaded = false;
    // SEO: ensure crawlers see an explicit indexing directive immediately
    // (set synchronously rather than in the idle callback).
    if (!document.querySelector('meta[name="robots"]')) {
      robotsEl = document.createElement('meta');
      robotsEl.setAttribute('name', 'robots');
      robotsEl.setAttribute('content', 'index, follow, max-image-preview:large, max-snippet:-1');
      document.head.appendChild(robotsEl);
    }
    const interactionEvents: Array<keyof DocumentEventMap> = ['pointerdown', 'keydown', 'touchstart'];
    const onFirstInteraction = () => {
      loadPixel();
      interactionEvents.forEach(ev => document.removeEventListener(ev, onFirstInteraction as any));
    };
    const handleCheckoutClick = (e: MouseEvent) => {
      const target = (e.target as HTMLElement)?.closest('a') as HTMLAnchorElement | null;
      if (target && target.href && target.href.includes('fegion.shop/cart')) {
        loadPixel();
        if ((window as any).fbq) {
          ;
          (window as any).fbq('track', 'InitiateCheckout');
        }
      }
    };
    const PIXEL_ID = '904978025482552';
    const loadPixel = () => {
      if (pixelLoaded || (window as any).fbq) return;
      pixelLoaded = true;
      const pixelScript = document.createElement('script');
      pixelScript.async = true;
      pixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${PIXEL_ID}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(pixelScript);
    };
    // Fire the pixel immediately on load so it's detectable by the Meta Pixel
    // Helper and PageView is recorded right away (no interaction required).
    loadPixel();
    const runDeferredSetup = () => {
      const ogTags = [{
        property: 'og:title',
        content: 'Matemáticas Sin Lágrimas — Todo el acompañamiento matemático de tu hijo listo.'
      }, {
        property: 'og:description',
        content: 'El sistema definitivo para padres de niños de 8 a 11 años. 5 Tomos + 3 Bonos.'
      }, {
        property: 'og:type',
        content: 'product'
      }, {
        property: 'og:locale',
        content: 'es_AR'
      }, {
        property: 'og:image',
        content: 'https://cdn.magicpatterns.com/uploads/jbnWXFE7WM5N12A9oKvrTY/Texto_del_parrafo_(4).webp'
      }, {
        property: 'twitter:card',
        content: 'summary_large_image'
      }, {
        property: 'twitter:title',
        content: 'Matemáticas Sin Lágrimas — Todo el acompañamiento matemático de tu hijo listo.'
      }, {
        property: 'twitter:description',
        content: 'El sistema definitivo para padres de niños de 8 a 11 años. 5 Tomos + 3 Bonos.'
      }, {
        property: 'twitter:image',
        content: 'https://cdn.magicpatterns.com/uploads/jbnWXFE7WM5N12A9oKvrTY/Texto_del_parrafo_(4).webp'
      }];
      ogTags.forEach(({
        property,
        content
      }) => {
        const existing = document.querySelector(`meta[property="${property}"]`);
        if (!existing) {
          const meta = document.createElement('meta');
          meta.setAttribute('property', property);
          meta.setAttribute('content', content);
          document.head.appendChild(meta);
        }
      });
      jsonLd = document.createElement('script');
      jsonLd.type = 'application/ld+json';
      jsonLd.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Matemáticas Sin Lágrimas',
        description: 'El sistema definitivo para padres de niños de 8 a 11 años. 5 Tomos + 3 Bonos.',
        brand: {
          '@type': 'Brand',
          name: 'Matemáticas Sin Lágrimas'
        },
        offers: [{
          '@type': 'Offer',
          name: 'Sistema Completo',
          price: '19990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: '#pricing'
        }, {
          '@type': 'Offer',
          name: 'Sistema Premium',
          price: '29990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: '#pricing'
        }],
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          reviewCount: '800'
        }
      });
      document.head.appendChild(jsonLd);
      if (!document.querySelector('link[rel="canonical"]')) {
        canonicalEl = document.createElement('link');
        canonicalEl.rel = 'canonical';
        canonicalEl.href = window.location.origin + window.location.pathname;
        document.head.appendChild(canonicalEl);
      }
      if (!document.querySelector('meta[name="theme-color"]')) {
        const themeColor = document.createElement('meta');
        themeColor.setAttribute('name', 'theme-color');
        themeColor.setAttribute('content', '#FDFBF7');
        document.head.appendChild(themeColor);
      }
      interactionEvents.forEach(ev => document.addEventListener(ev, onFirstInteraction as any, {
        once: true,
        passive: true
      } as any));
      document.addEventListener('click', handleCheckoutClick);
    };
    const prefetchChunks = () => {
      import('./components/StatsAndTestimonials');
      import('./components/PainPoints');
      import('./components/Modules');
      setTimeout(() => {
        import('./components/ContentPreview');
        import('./components/Bonuses');
        import('./components/ResourcesPreview');
      }, 300);
      setTimeout(() => {
        import('./components/IsForYou');
        import('./components/Pricing');
        import('./components/CostComparison');
      }, 800);
      setTimeout(() => {
        import('./components/FinalCTA');
        import('./components/Footer');
        import('./components/PurchaseToast');
      }, 1500);
    };
    const mountToast = () => {
      setShowPurchaseToast(true);
      window.removeEventListener('scroll', mountToast);
      window.removeEventListener('pointerdown', mountToast);
      window.removeEventListener('keydown', mountToast);
    };
    window.addEventListener('scroll', mountToast, {
      once: true,
      passive: true
    });
    window.addEventListener('pointerdown', mountToast, {
      once: true,
      passive: true
    });
    window.addEventListener('keydown', mountToast, {
      once: true,
      passive: true
    });
    const ric: any = (window as any).requestIdleCallback || ((cb: any) => setTimeout(cb, 1));
    const cic: any = (window as any).cancelIdleCallback || ((id: any) => clearTimeout(id));
    const prefetchId = ric(prefetchChunks, {
      timeout: 500
    });
    const idleId = ric(runDeferredSetup, {
      timeout: 1500
    });
    return () => {
      cic(idleId);
      cic(prefetchId);
      if (jsonLd) jsonLd.remove();
      if (canonicalEl) canonicalEl.remove();
      if (robotsEl) robotsEl.remove();
      interactionEvents.forEach(ev => document.removeEventListener(ev, onFirstInteraction as any));
      document.removeEventListener('click', handleCheckoutClick);
      window.removeEventListener('scroll', mountToast);
      window.removeEventListener('pointerdown', mountToast);
      window.removeEventListener('keydown', mountToast);
    };
  }, []);
  return <div className="min-h-screen bg-background text-slate-600 font-body selection:bg-primary/30 selection:text-slate-900" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-primary focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold" data-id="element-1">
        Saltar al contenido principal
      </a>

      <main id="main-content" data-id="element-2">
        <Hero data-id="element-3" />
        <div className="lazy-sections" data-id="element-4">
          <Suspense fallback={null} data-id="element-5">
            <StatsAndTestimonials data-id="element-6" />
            <PainPoints data-id="element-7" />
            <Modules data-id="element-8" />
            <ContentPreview data-id="element-9" />
            <Bonuses data-id="element-10" />
            <ResourcesPreview data-id="element-11" />
            <IsForYou data-id="element-12" />
            <Pricing data-id="element-13" />
            <CostComparison data-id="element-14" />
            <FinalCTA data-id="element-15" />
          </Suspense>
        </div>
      </main>

      <Suspense fallback={null} data-id="element-16">
        <Footer data-id="element-17" />
        {showPurchaseToast && <PurchaseToast data-id="element-18" />}
      </Suspense>
    </div>;
}